import { Typography } from '@mui/material';
import React from 'react';

const WisDotAttribution: React.FC = () => {
  return (
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{ maxWidth: '40%' }}
    >
      Data provided by Wisconsin 511/WisDot
    </Typography>
  );
};

export default WisDotAttribution;
